import React, { type ReactNode, useState } from 'react';
import { CalendarClockIcon, LayoutDashboardIcon, LogOutIcon, MenuIcon, UsersRoundIcon, XIcon } from 'lucide-react';
import type { AdminProfile } from '../../hooks/useAdminAccess';
import { AdminBrand } from './AdminBrand';
interface AdminShellProps {
  profile: AdminProfile;
  onSignOut: () => void;
  children: ReactNode;
}
const navigation = [{
  href: '/admin',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  href: '/admin/prospectos',
  label: 'Prospectos',
  icon: UsersRoundIcon
}, {
  href: '/admin/seguimientos',
  label: 'Seguimientos',
  icon: CalendarClockIcon
}];
export function AdminShell({
  profile,
  onSignOut,
  children
}: AdminShellProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const path = window.location.pathname.replace(/\/+$/, '') || '/admin';
  const name = profile.full_name || profile.email || 'Usuario';
  const role = profile.role || 'Sin rol';
  return <div className="min-h-screen w-full bg-[#07111f] text-slate-100" data-id="element-168">
      <header className="sticky top-0 z-30 border-b border-white/10 bg-[#0b1728]/95 backdrop-blur lg:hidden" data-id="element-169">
        <div className="flex min-h-16 items-center justify-between gap-3 px-4" data-id="element-170">
          <AdminBrand compact data-id="element-171" />
          <button type="button" aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={menuOpen} onClick={() => setMenuOpen(current => !current)} className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 text-slate-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300" data-id="element-172">
            {menuOpen ? <XIcon className="h-5 w-5" data-id="element-173" /> : <MenuIcon className="h-5 w-5" data-id="element-174" />}
          </button>
        </div>
        {menuOpen && <nav className="border-t border-white/10 px-3 py-3" aria-label="Navegación administrativa" data-id="element-175">
            <AdminNavigation path={path} onNavigate={() => setMenuOpen(false)} data-id="element-176" />
            <button type="button" onClick={onSignOut} className="mt-2 flex min-h-11 w-full items-center gap-3 rounded-xl px-3 text-left text-sm font-semibold text-slate-300 hover:bg-white/5" data-id="element-177">
              <LogOutIcon className="h-4 w-4" data-id="element-178" />
              Cerrar sesión
            </button>
          </nav>}
      </header>

      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r border-white/10 bg-[#0b1728] lg:flex lg:flex-col" data-id="element-179">
        <div className="border-b border-white/10 px-5 py-5" data-id="element-180">
          <AdminBrand data-id="element-181" />
        </div>
        <nav className="flex-1 px-3 py-5" aria-label="Navegación administrativa" data-id="element-182">
          <AdminNavigation path={path} data-id="element-183" />
        </nav>
        <div className="border-t border-white/10 p-4" data-id="element-184">
          <p className="truncate text-sm font-semibold text-white" data-id="element-185">{name}</p>
          <p className="mt-1 truncate text-xs uppercase tracking-[0.12em] text-cyan-200" data-id="element-186">
            {role}
          </p>
          <button type="button" onClick={onSignOut} className="mt-4 flex min-h-11 w-full items-center gap-3 rounded-xl border border-white/10 px-3 text-sm font-semibold text-slate-300 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300" data-id="element-187">
            <LogOutIcon className="h-4 w-4" data-id="element-188" />
            Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="min-w-0 lg:pl-64" data-id="element-189">{children}</main>
    </div>;
}
interface AdminNavigationProps {
  path: string;
  onNavigate?: () => void;
}
function AdminNavigation({
  path,
  onNavigate
}: AdminNavigationProps) {
  return <ul className="space-y-1" data-id="element-190">
      {navigation.map(item => {
      const active = item.href === '/admin' ? path === '/admin' : path === item.href || path.startsWith(`${item.href}/`);
      const Icon = item.icon;
      return <li key={item.href} data-id="element-191">
            <a href={item.href} onClick={onNavigate} className={`flex min-h-11 items-center gap-3 rounded-xl px-3 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-300 ${active ? 'bg-cyan-300/10 text-cyan-100' : 'text-slate-300 hover:bg-white/5 hover:text-white'}`} data-id="element-192">
              <Icon className="h-4 w-4" data-id="element-193" />
              {item.label}
            </a>
          </li>;
    })}
    </ul>;
}